import { CreateTransactionsObject } from "../../pages/Transactions";
import { baseApi, transactionRipple } from "../api";
import { transformRecurringTransactionPayload } from "./selector";
import { RecurringTransactionsResponse } from "./types";

interface UpdateRecurringTransactionArgs {
  recurringTransactionId: number;
  recurringTransaction: CreateTransactionsObject;
}

export const recurringTransactionsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRecurringTransactions: builder.query<
      RecurringTransactionsResponse[],
      number | void
    >({
      query: (accountId) => ({
        url: "/recurring-transactions",
        params: accountId === undefined ? {} : { accountId },
      }),
      providesTags: ["RecurringTransaction"],
    }),

    createRecurringTransaction: builder.mutation<
      void,
      CreateTransactionsObject
    >({
      query: (recurringTransaction) => ({
        url: "/recurring-transactions",
        method: "post",
        data: transformRecurringTransactionPayload(recurringTransaction),
      }),
      invalidatesTags: ["RecurringTransaction", ...transactionRipple()],
    }),

    updateRecurringTransaction: builder.mutation<
      void,
      UpdateRecurringTransactionArgs
    >({
      query: ({ recurringTransactionId, recurringTransaction }) => ({
        url: "/recurring-transactions/" + recurringTransactionId,
        method: "put",
        data: transformRecurringTransactionPayload(recurringTransaction),
      }),
      invalidatesTags: ["RecurringTransaction", ...transactionRipple()],
    }),

    /**
     * No transaction ripple: deleting a schedule leaves the transactions it
     * already generated intact, so no balance or total changes.
     */
    deleteRecurringTransaction: builder.mutation<void, number>({
      query: (recurringTransactionId) => ({
        url: "/recurring-transactions/" + recurringTransactionId,
        method: "delete",
      }),
      invalidatesTags: ["RecurringTransaction"],
    }),
  }),
});

export const {
  useGetRecurringTransactionsQuery,
  useLazyGetRecurringTransactionsQuery,
  useCreateRecurringTransactionMutation,
  useUpdateRecurringTransactionMutation,
  useDeleteRecurringTransactionMutation,
} = recurringTransactionsApi;
